export default __webpack_public_path__ + "static/media/class.0f62ec8d.svg";